<div class="panel" [attr.data-density]="density">

  <!-- Title bar 30px — drag handle, edge snap, collapse. -->
  <div class="panel__titlebar" (pointerdown)="onTitleBarPointerDown($event)">
    <div class="panel__dots" aria-hidden="true"><span></span><span></span></div>
    <div class="panel__wordmark">BUDDY</div>
    <div class="panel__chrome">
      <button type="button" class="panel__chrome-btn" aria-label="Chat history (Ctrl+J)" title="Chat history · Ctrl+J" (click)="onToggleHistory()">☰</button>
      <button type="button" class="panel__chrome-btn" [attr.aria-label]="collapseStyleLabel" [attr.title]="collapseStyleLabel" (click)="onToggleCollapseStyle()">{{ useEdgeTab ? '●' : '▐' }}</button>
      <button type="button" class="panel__chrome-btn" aria-label="Switch to the quest-rail layout" (click)="layoutToggleRequested.emit()">▥</button>
      <button type="button" class="panel__chrome-btn" aria-label="Snap to the other edge" (click)="edgeToggleRequested.emit()">⇱</button>
      <button type="button" class="panel__chrome-btn" aria-label="Collapse Buddy" (click)="collapseRequested.emit()">▭</button>
    </div>
  </div>

  <!-- Permanent gamification surface 1 of 3: the 3px XP rail. -->
  <div class="panel__rail" role="progressbar" [attr.aria-valuenow]="xpPct" aria-valuemin="0" aria-valuemax="100"
       [attr.aria-label]="'Level ' + progress.level + ' progress'">
    <div class="panel__rail-fill" [style.width.%]="xpPct"></div>
  </div>

  <!-- BB header 52px. Clicking BB's head opens the habitat sheet. -->
  <div class="panel__header">
    <button type="button" class="panel__bb" (click)="onOpenHabitat()" aria-label="Open BB’s habitat">
      <span class="panel__ring" [style.background]="'conic-gradient(' + xpColor + ' 0turn ' + ringTurns + 'turn, ' + trackColor + ' ' + ringTurns + 'turn 1turn)'"></span>
      <span class="panel__bb-inner">
        <app-bb-mascot [state]="bbState" [stage]="progress.stage" [size]="density === 'compact' ? 22 : 26"></app-bb-mascot>
      </span>
    </button>

    <div class="panel__identity">
      <span class="panel__name">{{ companionName }}</span>
      <!-- Permanent gamification surface 2 of 3: the level number. -->
      <span class="panel__level">{{ density === 'compact' ? compactLevelLine : levelLine }}</span>
    </div>

    <!-- Permanent gamification surface 3 of 3: the streak pill. -->
    <span class="panel__streak" [attr.aria-label]="progress.streakDays + ' day streak, ' + progress.multiplier + ' times XP'">
      {{ streakLabel }}
    </span>
    <span class="panel__badges" *ngIf="density === 'comfortable'">★ {{ progress.badges.length }}</span>
  </div>

  <!-- Daily quest strip — comfortable density only (3c). -->
  <div class="panel__quest" *ngIf="showQuestStrip">
    <span class="panel__quest-label">Daily quest</span>
    <span class="panel__quest-track"><span class="panel__quest-fill" [style.width.%]="questPct"></span></span>
    <span class="panel__quest-count">{{ progress.quest.done }}/{{ progress.quest.total }}</span>
  </div>

  <!-- Chat + overlays share this stacking context. -->
  <div class="panel__body">
    <app-buddy-chat-log
      [messages]="messages"
      [runs]="runs"
      [speakingMessageId]="speakingMessageId"
      (cancelRun)="onCancelRun($event)"
      (retryRun)="onRetryRun($event)"
      (decideRun)="onDecideRun($event)"
      (stopTts)="onStopTts()"
      (suggestionPicked)="onSuggestion($event)"
    ></app-buddy-chat-log>

    <app-buddy-workflow-palette
      *ngIf="paletteOpen"
      [workflows]="paletteWorkflows"
      [query]="paletteQuery"
      (runRequested)="onRunWorkflow($event)"
      (paramsRequested)="onWorkflowParams($event)"
      (defineRequested)="onDefineWorkflow()"
      (closed)="onClosePalette()"
    ></app-buddy-workflow-palette>

    <app-buddy-habitat
      *ngIf="habitatOpen"
      [progress]="progress"
      [bbState]="bbState"
      (closed)="onCloseHabitat()"
    ></app-buddy-habitat>

    <app-buddy-history *ngIf="historyOpen" (closed)="onCloseHistory()"></app-buddy-history>
  </div>

  <app-buddy-chip-rail
    *ngIf="showChipRail"
    [workflows]="railWorkflows"
    [overflowCount]="overflowCount"
    (runRequested)="onRunWorkflow($event)"
    (paramsRequested)="onWorkflowParams($event)"
    (overflowClicked)="onTogglePalette()"
  ></app-buddy-chip-rail>

  <app-buddy-input-row
    [ttsEnabled]="ttsEnabled"
    [micActive]="micActive"
    [handsFree]="handsFree"
    [streaming]="streaming"
    [transcript]="transcript"
    [showPaletteButton]="!showChipRail"
    [placeholder]="density === 'compact' ? 'Ask…' : 'Ask, or type / for workflows'"
    (submitted)="onSubmit($event)"
    (queryChanged)="onQueryChanged($event)"
    (micToggled)="onMicToggled()"
    (micHeld)="onMicHeld()"
    (ttsToggled)="onTtsToggled()"
    (paletteToggled)="onTogglePalette()"
    (stopRequested)="onStopStream()"
  ></app-buddy-input-row>
</div>
